module.exports = __webpack_public_path__ + "img/CosmicRare.2b2ec381.png";